import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { colspan: "3" };
import { CartItem } from "@/model/CartItem";
import { inject } from "vue";
import { Formatter } from "@/util/Formatter";
import { CartServiceSymbol } from "@/InjectionSymbols";
import { PriceType } from "@/model/enum/PriceType.model";
import ItemContentRow from "@/components/ItemContentRow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CheckoutCartRow',
    props: {
        cartItem: { type: CartItem, required: true }
    },
    setup(__props) {
        const cartService = inject(CartServiceSymbol);
        return (_ctx, _cache) => {
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_card_subtitle = _resolveComponent("v-card-subtitle");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, { class: "d-flex flex-wrap my-2 pa-2" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "text-start text-wrap v-col-12" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.cartItem.product.title), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_card_subtitle, { class: "text-start v-col-12" }, {
                        default: _withCtx(() => [
                            _createTextVNode("Buchungsdatum: " + _toDisplayString(_unref(cartService).getCartItemBuchungsdatum(__props.cartItem)), 1)
                        ]),
                        _: 1
                    }),
                    (__props.cartItem.selectedTimeslot)
                        ? (_openBlock(), _createBlock(_component_v_card_subtitle, {
                            key: 0,
                            class: "text-start v-col-12"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(" Zeitslot: " + _toDisplayString(__props.cartItem.selectedTimeslot.startTime.toString()) + " - " + _toDisplayString(__props.cartItem.selectedTimeslot.endTime.toString()), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createVNode(_component_v_table, { class: "compact w-100" }, {
                        default: _withCtx(() => [
                            _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", { class: "border-none" }),
                                    _createElementVNode("th", { class: "text-center border-none" }, "Preis"),
                                    _createElementVNode("th", { class: "text-center border-none" }, "Anzahl"),
                                    _createElementVNode("th", { class: "text-end border-none" }, "Zwischensumme")
                                ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                                _createVNode(ItemContentRow, {
                                    label: "Pauschal",
                                    "price-type": _unref(PriceType).FLAT_RATE,
                                    "cart-item": __props.cartItem
                                }, null, 8, ["price-type", "cart-item"]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(__props.cartItem.getAttributeReservations()), ([key], index) => {
                                    return (_openBlock(), _createBlock(ItemContentRow, {
                                        key: index,
                                        label: __props.cartItem.getResourceTitle(Number(key)),
                                        "price-type": _unref(PriceType).PER_RESOURCE,
                                        "cart-item": __props.cartItem,
                                        "reference-id": Number(key)
                                    }, null, 8, ["label", "price-type", "cart-item", "reference-id"]));
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(__props.cartItem.getResourceReservations()), ([key], index) => {
                                    return (_openBlock(), _createBlock(ItemContentRow, {
                                        key: index,
                                        label: __props.cartItem.getResourceTitle(Number(key)),
                                        "price-type": _unref(PriceType).PER_RESOURCE,
                                        "cart-item": __props.cartItem,
                                        "reference-id": Number(key)
                                    }, null, 8, ["label", "price-type", "cart-item", "reference-id"]));
                                }), 128)),
                                (Object.keys(__props.cartItem.priceAdjustments).length > 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _cache[0] || (_cache[0] = _createElementVNode("tr", { class: "no_border_row" }, [
                                            _createElementVNode("td", {
                                                colspan: "4",
                                                class: "text-start font-weight-bold pt-2"
                                            }, " Rabatte & Gebühren ")
                                        ], -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(__props.cartItem.priceAdjustments), (entry, index) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                _createElementVNode("td", _hoisted_1, _toDisplayString(entry[0]), 1),
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_v_container, { class: "py-0" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(Formatter).currency(entry[1])), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ])
                                            ]));
                                        }), 128))
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
